import {all, call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";
import {buildStatusCountersParams, buildTypeCountersParams} from "../helpers/filters";
import {FETCH_INTERVENTIONS} from "../constants/ActionTypes";
import Constants from "../services/Constants";
import User from "../services/User";

export const INTERVENTION_NON_ARCHIVED_STATUSES = Constants.STATUS_FILTER.map(s => s.value);

function* fetchInterventions(params) {
  try {
    const filters = {...params.filters};
    const hasExplicitStatuses = filters.interventionStatus && filters.interventionStatus.length;
    const isMissingArchived = filters.showArchived && !filters.interventionStatus.includes(Constants.STATUS_ARCHIVED.value);

    if (!hasExplicitStatuses) {
      filters.interventionStatus = filters.showArchived
        ? [...INTERVENTION_NON_ARCHIVED_STATUSES, Constants.STATUS_ARCHIVED.value]
        : INTERVENTION_NON_ARCHIVED_STATUSES;
    } else if (isMissingArchived) {
      filters.interventionStatus = [...filters.interventionStatus, Constants.STATUS_ARCHIVED.value];
    }

    const parameters = params.parameters;

    Object.keys(filters).forEach(key => {
      if ((filters[key] !== undefined) && (filters[key].length > 0 || Boolean(filters[key]))) {
        parameters[key] = filters[key];
      }
    });

    const [interventions, statusCountersData, typeCountersData] = yield all([
      call(() => Api.get('/interventions', parameters)),
      !User.isCallCenterAgent() ? call(() => Api.get('/interventions/count', buildStatusCountersParams({filters}))) : {body: {interventionStatus: {}}},
      !User.isCallCenterAgent() ? call(() => Api.get('/interventions/count', buildTypeCountersParams({filters}))) : {body: {type: {}}},
    ]);

    const statusCounters = statusCountersData.body.interventionStatus;
    const typeCounters = typeCountersData.body.type;

    yield put({type: 'FETCH_INTERVENTIONS.SUCCESS', interventions, statusCounters, typeCounters});
  } catch (error) {
    yield put({type: 'FETCH_INTERVENTIONS.FAILURE', error});
  }
}

function* fetchInterventionsOverview(params) {
  try {
    let parameters = params.parameters;

    Object.keys(params.filters).forEach(key => {
      if ((params.filters[key] !== undefined) && params.filters[key].length > 0) {
        parameters[key] = params.filters[key];
      }
    });

    const interventions = yield call(function () {
      return Api.get('/interventions/overview', parameters)
    });
    yield put({type: 'FETCH_INTERVENTIONS_OVERVIEW.SUCCESS', interventions});
  } catch (error) {
    yield put({type: 'FETCH_INTERVENTIONS_OVERVIEW.FAILURE', error});
  }
}


export function* watchFetchInterventions() {
  yield takeEvery(FETCH_INTERVENTIONS, fetchInterventions)
}

export function* watchFetchInterventionsOverview() {
  yield takeEvery('FETCH_INTERVENTIONS_OVERVIEW.REQUEST', fetchInterventionsOverview)
}
